import { IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { AccountType } from '../store/offer';

export function isManagementCompany({ accountType }: IAgentSchema) {
  return accountType === AccountType.ManagementCompany;
}
